import axios from "axios";

const BASE_URL = "https://gg-api.nationtonation.ca/api/tiered-prices";

export const fetchTieredPricesByProduct = async (productId: number) => {
  const response = await axios.get(`${BASE_URL}/product/${productId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return response.data;
};

export const createTieredPrice = async (data: {
  product_id: number;
  variant_id?: number | null;
  min_quantity: number;
  price_per_unit: number;
}) => {
  const response = await axios.post(BASE_URL, data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return response.data;
};

export const updateTieredPrice = async (id: number, updates: Partial<{ min_quantity: number; price_per_unit: number }>) => {
  const response = await axios.put(`${BASE_URL}/${id}`, updates, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return response.data;
};

export const deleteTieredPrice = async (id: number) => {
  const response = await axios.delete(`${BASE_URL}/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return response.data;
};

export const fetchTieredPriceTable = async (productId: number) => {
  const response = await axios.get(`${BASE_URL}/product/${productId}/table`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return response.data;
};